export default __webpack_public_path__ + "static/media/1200px-DigitalOcean_logo.svg.0ee1f2dd.png";